module.exports = __webpack_public_path__ + "img/yuan2.0.8bfe780f.jpg";